import React from 'react';
import PropTypes from 'prop-types';

const Video = ({ className, color }) => (
  <svg className={className} viewBox="0 0 21 14">
    <path
      d="M3 0h9a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm7.48 7.868l-3.984 2.277A1 1 0 0 1 5 9.277V4.723a1 1 0 0 1 1.496-.868l3.985 2.277a1 1 0 0 1 0 1.736zM16 9.578l.045-5.137 3.643-2.256s1.298-.732 1.312.718l-.067 8.25s-.046 1.376-1.395.62L16 9.578z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

Video.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default Video;
